import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { rootSelectors } from '@redux/modules/selectors';
import { ff, FeatureFlagIds } from 'helpers/featureFlags';

export interface FeatureFlagProps {
  when?: boolean
  ActiveComponent?: React.ComponentType<unknown>
  ActiveRender?: () => any | React.ReactNode
  InactiveComponent?: React.ComponentType<unknown>
  // The type is a bit weird as there is a typing bug with React.ReactNode and
  // FunctionComponent.
  InactiveRender?: () => any | React.ReactNode
  flagId: FeatureFlagIds
}

export const FeatureFlag: FunctionComponent<FeatureFlagProps> = ({
  when = true,
  ActiveComponent,
  ActiveRender,
  InactiveComponent,
  InactiveRender,
  flagId,
}) => {
  const features = ff(useSelector(rootSelectors.featureFlags.getFeatureFlags));

  if (features.getActive(flagId) && when) {
    if (ActiveComponent !== undefined) { return <ActiveComponent />; }
    if (ActiveRender !== undefined) { return ActiveRender(); }
  } else {
    if (InactiveComponent !== undefined) {
      return <InactiveComponent />;
    }
    if (InactiveRender !== undefined) {
      return InactiveRender();
    }
  }

  return null;
};
